"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = require("../index");

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Section = _styledComponents.default.section.withConfig({
  displayName: "Section",
  componentId: "ccux46-0"
})(["display:flex;flex-flow:column wrap;justify-content:space-between;margin-bottom:24px;", "{order:99;}@media ", "{display:block;position:relative;overflow:hidden;clear:both;", "{float:right;margin-left:48px;}", "{float:left;}}"], _index.Content, (0, _helpers.breakpoint)('minDesktop'), _index.Aside, _index.Content);

var _default = Section;
exports.default = _default;